module.exports = __webpack_public_path__ + "static/media/android.0cbf8862.png";